import React, { useEffect } from 'react';
import { SelectField } from '@flos/react-ui';
import useAppState from '../../state/appState';
import { ElementValue } from '../../types/form-values';
import { ClaimFormSubmitFieldValue } from '../../types/claim-form-submit-field-value';
import { Countries as CountriesType, FormValues, FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';
import { getIsValid, getValidationErrors } from '../../validators/validator-mapping';
import { SummaryRowTemplate } from '../../helpers/templates';
import { ElementValueHuman } from '../../types/element-values';
import { isRequired } from '../../helpers/isRequired';
import { getElementFromElementId } from '../../helpers/getElementFromElementId';
import { getValue } from '../values/Get';
import { getClaimFormSubmitValue } from '../../helpers/getClaimFormSubmitValue';

const getCountriesArray = () => {
    return [
        {
            value: 'select',
            caption: 'Vælg...'
        },
        {
            caption: 'Rundrejse Europa',
            value: 'ROUNDTRIP_EUROPE'
        },
        {
            caption: 'Rundrejse verden',
            value: 'ROUNDTRIP_WORLD'
        },
        {
            caption: 'Afghanistan',
            value: 'AF'
        },
        {
            caption: 'Albanien',
            value: 'AL'
        },
        {
            caption: 'Algeriet',
            value: 'DZ'
        },
        {
            caption: 'Amerikansk Samoa',
            value: 'AS'
        },
        {
            caption: 'Amerikanske Jomfruøer',
            value: 'VI'
        },
        {
            caption: 'Andorra',
            value: 'AD'
        },
        {
            caption: 'Angola',
            value: 'AO'
        },
        {
            caption: 'Anguilla',
            value: 'AI'
        },
        {
            caption: 'Antarktis',
            value: 'AQ'
        },
        {
            caption: 'Antigua og Barbuda',
            value: 'AG'
        },
        {
            caption: 'Argentina',
            value: 'AR'
        },
        {
            caption: 'Armenien',
            value: 'AM'
        },
        {
            caption: 'Aruba',
            value: 'AW'
        },
        {
            caption: 'Aserbajdsjan',
            value: 'AZ'
        },
        {
            caption: 'Australien',
            value: 'AU'
        },
        {
            caption: 'Bahamas',
            value: 'BS'
        },
        {
            caption: 'Bahrain',
            value: 'BH'
        },
        {
            caption: 'Bangladesh',
            value: 'BD'
        },
        {
            caption: 'Barbados',
            value: 'BB'
        },
        {
            caption: 'Belgien',
            value: 'BE'
        },
        {
            caption: 'Belize',
            value: 'BZ'
        },
        {
            caption: 'Benin',
            value: 'BJ'
        },
        {
            caption: 'Bermuda',
            value: 'BM'
        },
        {
            caption: 'Bhutan',
            value: 'BT'
        },
        {
            caption: 'Bolivia',
            value: 'BO'
        },
        {
            caption: 'Bonaire, St. Eustatius og Saba',
            value: 'BQ'
        },
        {
            caption: 'Bosnien-Hercegovina',
            value: 'BA'
        },
        {
            caption: 'Botswana',
            value: 'BW'
        },
        {
            caption: 'Bouvetøen',
            value: 'BV'
        },
        {
            caption: 'Brasilien',
            value: 'BR'
        },
        {
            caption: 'Britisk territorium i det Indiske Ocean',
            value: 'IO'
        },
        {
            caption: 'Britiske Jomfruøer',
            value: 'VG'
        },
        {
            caption: 'Brunei Darussalam',
            value: 'BN'
        },
        {
            caption: 'Bulgarien',
            value: 'BG'
        },
        {
            caption: 'Burkina Faso',
            value: 'BF'
        },
        {
            caption: 'Burundi',
            value: 'BI'
        },
        {
            caption: 'Cambodja',
            value: 'KH'
        },
        {
            caption: 'Cameroun',
            value: 'CM'
        },
        {
            caption: 'Canada',
            value: 'CA'
        },
        {
            caption: 'Caymanøerne',
            value: 'KY'
        },
        {
            caption: 'Centralafrikanske Republik',
            value: 'CF'
        },
        {
            caption: 'Chile',
            value: 'CL'
        },
        {
            caption: 'Christmas Island',
            value: 'CX'
        },
        {
            caption: 'Cocosøerne',
            value: 'CC'
        },
        {
            caption: 'Colombia',
            value: 'CO'
        },
        {
            caption: 'Comorerne',
            value: 'KM'
        },
        {
            caption: 'Cookøerne',
            value: 'CK'
        },
        {
            caption: 'Costa Rica',
            value: 'CR'
        },
        {
            caption: 'Cuba',
            value: 'CU'
        },
        {
            caption: 'Curaçao',
            value: 'CW'
        },
        {
            caption: 'Cypern',
            value: 'CY'
        },
        {
            caption: 'Danmark',
            value: 'DK'
        },
        {
            caption: 'Demokratiske Republik Congo',
            value: 'CD'
        },
        {
            caption: 'Djibouti',
            value: 'DJ'
        },
        {
            caption: 'Dominica',
            value: 'DM'
        },
        {
            caption: 'Dominikanske Republik',
            value: 'DO'
        },
        {
            caption: 'Ecuador',
            value: 'EC'
        },
        {
            caption: 'Egypten',
            value: 'EG'
        },
        {
            caption: 'El Salvador',
            value: 'SV'
        },
        {
            caption: 'Elfenbenskysten',
            value: 'CI'
        },
        {
            caption: 'Eritrea',
            value: 'ER'
        },
        {
            caption: 'Estland',
            value: 'EE'
        },
        {
            caption: 'Etiopien',
            value: 'ET'
        },
        {
            caption: 'Falklandsøerne ',
            value: 'FK'
        },
        {
            caption: 'Fiji',
            value: 'FJ'
        },
        {
            caption: 'Filippinerne',
            value: 'PH'
        },
        {
            caption: 'Finland',
            value: 'FI'
        },
        {
            caption: 'Forenede Arabiske Emirater',
            value: 'AE'
        },
        {
            caption: 'Frankrig',
            value: 'FR'
        },
        {
            caption: 'Fransk Guyana',
            value: 'GF'
        },
        {
            caption: 'Fransk Polynesien',
            value: 'PF'
        },
        {
            caption: 'Franske Sydlige Territorier',
            value: 'TF'
        },
        {
            caption: 'Færøerne',
            value: 'FO'
        },
        {
            caption: 'Gabon',
            value: 'GA'
        },
        {
            caption: 'Gambia',
            value: 'GM'
        },
        {
            caption: 'Georgien',
            value: 'GE'
        },
        {
            caption: 'Ghana',
            value: 'GH'
        },
        {
            caption: 'Gibraltar',
            value: 'GI'
        },
        {
            caption: 'Grenada',
            value: 'GD'
        },
        {
            caption: 'Grækenland',
            value: 'GR'
        },
        {
            caption: 'Grønland',
            value: 'GL'
        },
        {
            caption: 'Guadeloupe',
            value: 'GP'
        },
        {
            caption: 'Guam',
            value: 'GU'
        },
        {
            caption: 'Guatemala',
            value: 'GT'
        },
        {
            caption: 'Guernsey',
            value: 'GG'
        },
        {
            caption: 'Guinea',
            value: 'GN'
        },
        {
            caption: 'Guinea-Bissau',
            value: 'GW'
        },
        {
            caption: 'Guyana',
            value: 'GY'
        },
        {
            caption: 'Haiti',
            value: 'HT'
        },
        {
            caption: 'Heard Island og McDonald Islands',
            value: 'HM'
        },
        {
            caption: 'Holland',
            value: 'NL'
        },
        {
            caption: 'Honduras',
            value: 'HN'
        },
        {
            caption: 'Hongkong',
            value: 'HK'
        },
        {
            caption: 'Hviderusland',
            value: 'BY'
        },
        {
            caption: 'Indien',
            value: 'IN'
        },
        {
            caption: 'Indonesien',
            value: 'ID'
        },
        {
            caption: 'Irak',
            value: 'IQ'
        },
        {
            caption: 'Iran',
            value: 'IR'
        },
        {
            caption: 'Irland',
            value: 'IE'
        },
        {
            caption: 'Island',
            value: 'IS'
        },
        {
            caption: 'Isle of Man',
            value: 'IM'
        },
        {
            caption: 'Israel',
            value: 'IL'
        },
        {
            caption: 'Italien',
            value: 'IT'
        },
        {
            caption: 'Jamaica',
            value: 'JM'
        },
        {
            caption: 'Japan',
            value: 'JP'
        },
        {
            caption: 'Jersey',
            value: 'JE'
        },
        {
            caption: 'Jordan',
            value: 'JO'
        },
        {
            caption: 'Kap Verde',
            value: 'CV'
        },
        {
            caption: 'Kasakhstan',
            value: 'KZ'
        },
        {
            caption: 'Kenya',
            value: 'KE'
        },
        {
            caption: 'Kina',
            value: 'CN'
        },
        {
            caption: 'Kirgisistan',
            value: 'KG'
        },
        {
            caption: 'Kiribati',
            value: 'KI'
        },
        {
            caption: 'Kosovo',
            value: 'XK'
        },
        {
            caption: 'Kroatien',
            value: 'HR'
        },
        {
            caption: 'Kuwait',
            value: 'KW'
        },
        {
            caption: 'Laos',
            value: 'LA'
        },
        {
            caption: 'Lesotho',
            value: 'LS'
        },
        {
            caption: 'Letland',
            value: 'LV'
        },
        {
            caption: 'Libanon',
            value: 'LB'
        },
        {
            caption: 'Liberia',
            value: 'LR'
        },
        {
            caption: 'Libyen',
            value: 'LY'
        },
        {
            caption: 'Liechtenstein',
            value: 'LI'
        },
        {
            caption: 'Litauen',
            value: 'LT'
        },
        {
            caption: 'Luxembourg',
            value: 'LU'
        },
        {
            caption: 'Macao',
            value: 'MO'
        },
        {
            caption: 'Madagaskar',
            value: 'MG'
        },
        {
            caption: 'Makedonien',
            value: 'MK'
        },
        {
            caption: 'Malawi',
            value: 'MW'
        },
        {
            caption: 'Malaysia',
            value: 'MY'
        },
        {
            caption: 'Maldiverne',
            value: 'MV'
        },
        {
            caption: 'Mali',
            value: 'ML'
        },
        {
            caption: 'Malta',
            value: 'MT'
        },
        {
            caption: 'Marokko',
            value: 'MA'
        },
        {
            caption: 'Marshalløerne',
            value: 'MH'
        },
        {
            caption: 'Martinique',
            value: 'MQ'
        },
        {
            caption: 'Mauretanien',
            value: 'MR'
        },
        {
            caption: 'Mauritius',
            value: 'MU'
        },
        {
            caption: 'Mayotte',
            value: 'YT'
        },
        {
            caption: 'Mexico',
            value: 'MX'
        },
        {
            caption: 'Mikronesien',
            value: 'FM'
        },
        {
            caption: 'Moldova',
            value: 'MD'
        },
        {
            caption: 'Monaco',
            value: 'MC'
        },
        {
            caption: 'Mongoliet',
            value: 'MN'
        },
        {
            caption: 'Montenegro',
            value: 'ME'
        },
        {
            caption: 'Montserrat',
            value: 'MS'
        },
        {
            caption: 'Mozambique',
            value: 'MZ'
        },
        {
            caption: 'Myanmar',
            value: 'MM'
        },
        {
            caption: 'Namibia',
            value: 'NA'
        },
        {
            caption: 'Nauru',
            value: 'NR'
        },
        {
            caption: 'Nepal',
            value: 'NP'
        },
        {
            caption: 'New Zealand',
            value: 'NZ'
        },
        {
            caption: 'Nicaragua',
            value: 'NI'
        },
        {
            caption: 'Niger',
            value: 'NE'
        },
        {
            caption: 'Nigeria',
            value: 'NG'
        },
        {
            caption: 'Niue',
            value: 'NU'
        },
        {
            caption: 'Nordkorea (Den Demokratiske Folkerepublik Korea)',
            value: 'KP'
        },
        {
            caption: 'Nordmarianerne',
            value: 'MP'
        },
        {
            caption: 'Norfolk Island',
            value: 'NF'
        },
        {
            caption: 'Norge',
            value: 'NO'
        },
        {
            caption: 'Ny Kaledonien',
            value: 'NC'
        },
        {
            caption: 'Oman',
            value: 'OM'
        },
        {
            caption: 'Pakistan',
            value: 'PK'
        },
        {
            caption: 'Palau',
            value: 'PW'
        },
        {
            caption: 'Palæstina',
            value: 'PS'
        },
        {
            caption: 'Panama',
            value: 'PA'
        },
        {
            caption: 'Papua Ny Guinea',
            value: 'PG'
        },
        {
            caption: 'Paraguay',
            value: 'PY'
        },
        {
            caption: 'Peru',
            value: 'PE'
        },
        {
            caption: 'Pitcairn',
            value: 'PN'
        },
        {
            caption: 'Polen',
            value: 'PL'
        },
        {
            caption: 'Portugal',
            value: 'PT'
        },
        {
            caption: 'Puerto Rico',
            value: 'PR'
        },
        {
            caption: 'Qatar',
            value: 'QA'
        },
        {
            caption: 'Republikken Congo',
            value: 'CG'
        },
        {
            caption: 'Rumænien',
            value: 'RO'
        },
        {
            caption: 'Rusland',
            value: 'RU'
        },
        {
            caption: 'Rwanda',
            value: 'RW'
        },
        {
            caption: 'Réunion',
            value: 'RE'
        },
        {
            caption: 'Saint Barthélemy',
            value: 'BL'
        },
        {
            caption: 'Saint Helena, Ascension og Tristan da Cunha',
            value: 'SH'
        },
        {
            caption: 'Saint Kitts og Nevis',
            value: 'KN'
        },
        {
            caption: 'Saint Lucia',
            value: 'LC'
        },
        {
            caption: 'Saint Martin (fransk)',
            value: 'MF'
        },
        {
            caption: 'Saint Vincent og Grenadinerne',
            value: 'VC'
        },
        {
            caption: 'Saint-Pierre og Miquelon',
            value: 'PM'
        },
        {
            caption: 'Salomonøerne',
            value: 'SB'
        },
        {
            caption: 'Samoa',
            value: 'WS'
        },
        {
            caption: 'San Marino',
            value: 'SM'
        },
        {
            caption: 'Saudi-Arabien',
            value: 'SA'
        },
        {
            caption: 'Schweiz',
            value: 'CH'
        },
        {
            caption: 'Senegal',
            value: 'SN'
        },
        {
            caption: 'Serbien',
            value: 'RS'
        },
        {
            caption: 'Seychellerne',
            value: 'SC'
        },
        {
            caption: 'Sierra Leone',
            value: 'SL'
        },
        {
            caption: 'Singapore',
            value: 'SG'
        },
        {
            caption: 'Sint Maarten (nederlandsk)',
            value: 'SX'
        },
        {
            caption: 'Slovakiet',
            value: 'SK'
        },
        {
            caption: 'Slovenien',
            value: 'SI'
        },
        {
            caption: 'Somalia',
            value: 'SO'
        },
        {
            caption: 'South Georgia og South Sandwich Islands',
            value: 'GS'
        },
        {
            caption: 'Spanien',
            value: 'ES'
        },
        {
            caption: 'Sri Lanka',
            value: 'LK'
        },
        {
            caption: 'Storbritannien',
            value: 'GB'
        },
        {
            caption: 'Sudan',
            value: 'SD'
        },
        {
            caption: 'Surinam',
            value: 'SR'
        },
        {
            caption: 'Svalbard og Jan Mayen',
            value: 'SJ'
        },
        {
            caption: 'Sverige',
            value: 'SE'
        },
        {
            caption: 'Swaziland',
            value: 'SZ'
        },
        {
            caption: 'Sydafrika',
            value: 'ZA'
        },
        {
            caption: 'Sydkorea (Republikken Korea)',
            value: 'KR'
        },
        {
            caption: 'Sydsudan',
            value: 'SS'
        },
        {
            caption: 'Syrien',
            value: 'SY'
        },
        {
            caption: 'São Tomé og Príncipe',
            value: 'ST'
        },
        {
            caption: 'Tadsjikistan',
            value: 'TJ'
        },
        {
            caption: 'Taiwan',
            value: 'TW'
        },
        {
            caption: 'Tanzania',
            value: 'TZ'
        },
        {
            caption: 'Tchad',
            value: 'TD'
        },
        {
            caption: 'Thailand',
            value: 'TH'
        },
        {
            caption: 'Tjekkiet',
            value: 'CZ'
        },
        {
            caption: 'Togo',
            value: 'TG'
        },
        {
            caption: 'Tokelau',
            value: 'TK'
        },
        {
            caption: 'Tonga',
            value: 'TO'
        },
        {
            caption: 'Trinidad og Tobago',
            value: 'TT'
        },
        {
            caption: 'Tunesien',
            value: 'TN'
        },
        {
            caption: 'Turkmenistan',
            value: 'TM'
        },
        {
            caption: 'Turks- og Caicosøerne',
            value: 'TC'
        },
        {
            caption: 'Tuvalu',
            value: 'TV'
        },
        {
            caption: 'Tyrkiet',
            value: 'TR'
        },
        {
            caption: 'Tyskland',
            value: 'DE'
        },
        {
            caption: 'USA',
            value: 'US'
        },
        {
            caption: 'USA\u0027s ydre småøer',
            value: 'UM'
        },
        {
            caption: 'Uganda',
            value: 'UG'
        },
        {
            caption: 'Ukraine',
            value: 'UA'
        },
        {
            caption: 'Ungarn',
            value: 'HU'
        },
        {
            caption: 'Uruguay',
            value: 'UY'
        },
        {
            caption: 'Usbekistan',
            value: 'UZ'
        },
        {
            caption: 'Vanuatu',
            value: 'VU'
        },
        {
            caption: 'Vatikanstaten',
            value: 'VA'
        },
        {
            caption: 'Venezuela',
            value: 'VE'
        },
        {
            caption: 'Vestsahara',
            value: 'EH'
        },
        {
            caption: 'Vietnam',
            value: 'VN'
        },
        {
            caption: 'Wallis og Futuna',
            value: 'WF'
        },
        {
            caption: 'Yemen',
            value: 'YE'
        },
        {
            caption: 'Zambia',
            value: 'ZM'
        },
        {
            caption: 'Zimbabwe',
            value: 'ZW'
        },
        {
            caption: 'Ålandsøerne',
            value: 'AX'
        },
        {
            caption: 'Ækvatorialguinea',
            value: 'GQ'
        },
        {
            caption: 'Østrig',
            value: 'AT'
        },
        {
            caption: 'Østtimor',
            value: 'TL'
        }
    ];
};

const Countries = ({ elementId, caption, placeholder, helpText }: CountriesType) => {
    const formConfig = useAppState((state) => state.formConfig);
    const formValues = useAppState((state) => state.formValues);
    const setFormValue = useAppState((state) => state.setFormValue);

    const value = Countries.getValueOrDefault(formValues, elementId);

    const [errorMessage, setErrorMessage] = React.useState('');

    type Options = {
        value: string;
        caption: string;
    };

    const [countries, setCountries] = React.useState<Options[]>([]);

    const [fieldHasHadFocusAtLeastOnce, setFieldHasHadFocusAtLeastOnce] = React.useState(false);

    const doValidation = () => {
        if (!formConfig) {
            return;
        }

        if (!fieldHasHadFocusAtLeastOnce) {
            return;
        }

        const errorMessages = getValidationErrors(formConfig, formValues, elementId);
        setErrorMessage(errorMessages[0]);
    };

    useEffect(() => {
        const countries = getCountriesArray();

        setCountries(countries);
    }, []);

    useEffect(() => {
        doValidation();
        // eslint-disable-next-line
    }, [value]);

    const isRequiredField = isRequired(formConfig, elementId);

    const isValid = Countries.isValidField(formConfig, formValues, elementId, fieldHasHadFocusAtLeastOnce);

    return (
        <>
            {caption && <h6>{caption}</h6>}
            <SelectField
                required={isRequiredField}
                label={placeholder}
                id={elementId}
                key={elementId}
                options={countries.map((option) => ({
                    label: option.caption,
                    value: option.value
                }))}
                isValid={isValid}
                helpText={helpText}
                errorText={errorMessage}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                    const value = event.target.value;
                    setFormValue(elementId, value);
                    setFieldHasHadFocusAtLeastOnce(true);
                }}
                value={value}
            />
        </>
    );
};

Countries.ResumePage = (formConfig: FormConfig, formValues: FormValues, elementId: string): JSX.Element => {
    const element = getElementFromElementId(formConfig, elementId) as CountriesType;
    const { summaryCaption } = element;

    const value = getValue(formConfig, formValues, elementId);

    // Happens when the user has not filled
    // out previous pages but somehow navigated to the resume page
    if (value === undefined) {
        return <></>;
    }

    const countries = getCountriesArray();
    const option = countries.find((item) => item.value === value);
    const caption = option?.caption;

    return <SummaryRowTemplate elementId={elementId} caption={summaryCaption} value={caption} />;
};

Countries.getValueSubmit = (formValues: FormValues, elementId: string, label: string): ClaimFormSubmitFieldValue => {
    //const value = Countries.getValue(formValues, elementId);
    const valueStr = Countries.getValueHuman(formValues, elementId);

    // FRY: using valueStr as valueId here is intentional, as requested by Daryl (CA uses the Danish labels, e.g. 'Danmark' and not 'DK')
    //const valueId = { string: value };
    const valueId = { string: valueStr };

    return getClaimFormSubmitValue('countries', elementId, label, valueStr, valueId);
};

Countries.getValue = (formValues: FormValues, elementId: string): ElementValue => {
    return formValues[elementId];
};

Countries.getValueOrDefault = (formValues: FormValues, elementId: string) => {
    const value = Countries.getValue(formValues, elementId);
    if (value === undefined) {
        return '';
    }
    return value;
};

Countries.getValueHuman = (formValues: FormValues, elementId: string): ElementValueHuman => {
    const value = Countries.getValue(formValues, elementId);

    const countries = getCountriesArray();
    const selectedCountry = countries.find((c) => c.value === value);

    return selectedCountry ? selectedCountry.caption : value;
};

Countries.isValid = (formConfig: FormConfig, formValues: FormValues, elementId: string): boolean => {
    return getIsValid(formConfig, formValues, elementId);
};

Countries.isValidField = (
    formConfig: FormConfig | undefined,
    formValues: FormValues,
    elementId: string,
    fieldHasHadFocusAtLeastOnce: boolean
): boolean | undefined => {
    if (!formConfig) {
        return undefined;
    }

    if (!fieldHasHadFocusAtLeastOnce) {
        return undefined;
    }

    const isValid = Countries.isValid(formConfig, formValues, elementId);

    return isValid;
};

export default Countries;
